import classNames from 'classnames';
import { Edit } from '@carbon/react/icons';
import { FloatingTooltip } from 'components/floating-tooltip/floating-tooltip';
import styles from './edit-pencil-button.module.scss';

export interface EditPencilButtonProps {
  /** Accessible label + tooltip text (e.g. "Edit AFE Source"). */
  label: string;
  /** Invoked on click; row-click propagation is stopped for you. */
  onClick: () => void;
  /** Optional extra class for layout overrides. */
  className?: string;
}

/**
 * A small transparent edit-pencil button with a tooltip, for inline-edit table
 * cells. Stops click propagation so it doesn't trigger row selection/expansion.
 *
 * @param {EditPencilButtonProps} props - Label, click handler, and optional class.
 * @return {JSX.Element} The pencil button.
 */
export function EditPencilButton({
  label,
  onClick,
  className,
}: EditPencilButtonProps) {
  return (
    <FloatingTooltip content={label} placement="top">
      <button
        type="button"
        className={classNames(styles.button, className)}
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <Edit />
      </button>
    </FloatingTooltip>
  );
}
